import { flatMap } from 'lodash';
import { ProjectTemplateSpaceTab } from '../types';
import { useProjectTemplateSpaces } from './use-get-all-spaces';

export const useProjectTemplateSpaceTabs = (): AtLeast<
  ProjectTemplateSpaceTab,
  'spaceTabId' | 'spaceTabType' | 'spaceTabTitle'
>[] => {
  const spaces = useProjectTemplateSpaces();
  const spaceTabs = flatMap(
    Object.values(spaces).map((space) => space.spaceTabs),
  );

  return spaceTabs;
};
